import "core-js/modules/es.array.concat.js";
import React, { useEffect } from 'react';
import { ChartStateTypes, StyledEmptyStateButton, StyledEmptyStateFilter, StyledEmptyStateHeading, StyledEmptyStateWrapper } from "./utils/global";
import { Loading } from '@applyboard/ui-components';
import { useEventTracker } from '@applyboard/ui-utils';
export var ChartEmptyState = function ChartEmptyState(_ref) {
  var chartState = _ref.chartState,
    chartSubtitle = _ref.chartSubtitle,
    chartTitle = _ref.chartTitle,
    height = _ref.height,
    onFilterClear = _ref.onFilterClear;
  var _useEventTracker = useEventTracker(),
    trackEvent = _useEventTracker.trackEvent;
  var reportName = chartTitle;
  if (chartSubtitle) reportName = "".concat(reportName, " - ").concat(chartSubtitle);
  useEffect(function () {
    trackEvent({
      event: 'Agent Dashboard - Returned Empty Report',
      data: {
        reportName: reportName
      }
    });
  }, []);
  return /*#__PURE__*/React.createElement(StyledEmptyStateWrapper, {
    "data-testid": "empty-state-chart",
    height: height
  }, chartState === ChartStateTypes.LOADING ? /*#__PURE__*/React.createElement(Loading, null) : /*#__PURE__*/React.createElement(React.Fragment, null, /*#__PURE__*/React.createElement(StyledEmptyStateHeading, null, "No Data Available to Display"), onFilterClear && /*#__PURE__*/React.createElement(StyledEmptyStateFilter, null, "Please make a different filter selection", /*#__PURE__*/React.createElement("span", null, "OR"), /*#__PURE__*/React.createElement(StyledEmptyStateButton, {
    variant: "outlined",
    onClick: onFilterClear
  }, "Clear filters"))));
};